import React, { useMemo, useEffect } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchDoctorDegree } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";

const DoctorDegreeDropdown = ({
  errors,
  control,
  setValue,
  getValues,
  watch,
  rowData,
}) => {
  const degreeName = rowData?.degree_name
    ? rowData.degree_name
    : rowData?.degree_obj?.degree
      ? rowData.degree_obj.degree
      : getValues().degree_name;

  const selectedDegree = watch("doctor_degree_id");

  const {
    data: degrees,
    isLoading,
    error,
    refetch,
  } = useQuery(["degrees"], () => fetchDoctorDegree(), {
    keepPreviousData: false,
    staleTime: DROPDOWN_STALE_TIME,
  });

  useEffect(() => {
    refetch();
  }, [rowData]);

  const modifiedData = useMemo(() => {
    return (
      degrees?.data?.data?.map((ele) => ({
        value: ele.id,
        label: ele.degree_name,
      })) || []
    );
  }, [degrees]);

  const options = useMemo(() => modifiedData, [modifiedData]);

  const selectedOption = useMemo(() => {
    return (
      options.find((option) => option.value === selectedDegree) ||
      options.find((option) => option.label === degreeName) ||
      null
    );
  }, [options, selectedDegree, degreeName]);

  useEffect(() => {
    if (rowData && options.length) {
      const rowDataOption = options.find(
        (option) => option.value === rowData?.doctor_degree_id
      );
      setValue("doctor_degree_id", rowDataOption?.value);
      setValue("degree_name", rowDataOption?.label);
    }
  }, [rowData, options, setValue]);

  useEffect(() => {
    if (selectedOption) {
      setValue("doctor_degree_id", selectedOption.value);
      setValue("degree_name", selectedOption.label);
    }
  }, [selectedOption, setValue]);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading Doctor's Degree</div>;

  return (
    <Controller
      name="doctor_degree_id"
      control={control}
      rules={{ required: "Degree is required" }}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isClearable
          value={selectedOption || null}
          placeholder="Select Doctor's Degree"
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          onChange={(selectedOption) => {
            const value = selectedOption ? selectedOption.value : "";
            field.onChange(value);
            setValue("doctor_degree_id", value);
            setValue(
              "degree_name",
              selectedOption ? selectedOption.label : ""
            );
          }}
          className={`react-select-container ${errors.doctor_degree_id ? "is-invalid" : ""
            }`}
        />
      )}
    />
  );
};

export default DoctorDegreeDropdown;